module.exports = __webpack_public_path__ + "img/woonbox.be40ab34.svg";